import {FC, useContext} from 'react';
//formik
import {useFormikContext} from 'formik';
import {CreateEventFormValues} from '../formConfiguration';
//context
import {CreateNewEventContext} from '../OrganizationSignUpContext';
//mui
import {Box} from '@mui/material';
//components
import Button from '@/shared/components/Button';
//constants
import {BACK, CANCEL, CONFIRM, CONTINUE, OUTLINE, PRIMARY, defaultStep} from '@/utils/constants';
import {CREATE_EVENT_STEP} from '../helpers';
//styles
import {eventActionsStyle} from './EventActions.styles';

const EventActions: FC = () => {
	const {activeStep, onCloseModal, handleBackStep} = useContext(CreateNewEventContext);

	const {submitForm} = useFormikContext<CreateEventFormValues>();

	return (
		<Box sx={eventActionsStyle.wrapper}>
			<Button
				title={activeStep === defaultStep ? CANCEL : BACK}
				sx={eventActionsStyle.button}
				onClick={activeStep === defaultStep ? onCloseModal : handleBackStep}
				variant={OUTLINE}
				color={PRIMARY}
				disableRipple
			/>

			<Button
				title={activeStep === CREATE_EVENT_STEP.WEBPAGE ? CONFIRM : CONTINUE}
				sx={eventActionsStyle.button}
				onClick={submitForm}
				disableRipple
			/>
		</Box>
	);
};

export default EventActions;
